// TESTS:
// const config = {
//   apiKey: 'AIzaSyCboDfHROh7suUiKYKh-raORX7CZYileqY',
//   authDomain: 'neolivrostest.firebaseapp.com',
//   databaseURL: 'https://neolivrostest.firebaseio.com',
//   projectId: 'neolivrostest',
//   storageBucket: 'neolivrostest.appspot.com',
//   messagingSenderId: '1039712968089'
// }

const config = {
  apiKey: 'AIzaSyAtqvDVIV1gWTfpNYMLybJUoF07_U7Inu0',
  authDomain: 'neolivros-23b59.firebaseapp.com',
  databaseURL: 'https://neolivros-23b59.firebaseio.com',
  projectId: 'neolivros-23b59',
  storageBucket: 'neolivros-23b59.appspot.com',
  messagingSenderId: '812222905160'
}

export default config



// WEBPACK FOOTER //
// ./src/firebase_config/config.js